<template>
  <div>
    <accnav
      :list="navList"
      :curTitleId="curTitleId"
      @titleChange="titleChange"
    ></accnav>
    <div>
      <component :is="child"></component>
    </div>
  </div>
</template>

<script>
import accnav from '../../common/accnav.vue'
import integral from './children/integral.vue'
export default {
  data: function () {
    return {
      curTitleId: 1, //
      navList: [{
        id: 1,
        name: '我的积分',
      },{
        id: 2,
        name: '积分商城',
      },{
        id: 3,
        name: '我的订单',
      },{
        id: 4,
        name: '我的快递',
      }],
      loading: false,
    }
  },
  computed: {
    child: function () {
      switch (this.curTitleId) {
        case 1:
         return integral
         break
        case 2:
         return integral
         break
        case 3:
         return integral
         break
        case 4:
         return integral
         break
      }
    }
  },
  components:{accnav},
  methods:{
    titleChange: function (id) {
      this.curTitleId = id
    },
    toCourseDetail: function (id) {
      this.$router.push({
          path : 'CourseDetail',
          query : {id : id},
      })
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
  .task_list{
    position: relative;
  }
.task-pagination{
  text-align: center;
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccAccound/AccAccound.vue